
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 56.36c13.255 0 24-10.746 24-24 0-13.256-10.745-24-24-24s-24 10.744-24 24c0 13.254 10.745 24 24 24z","stroke":"#fff","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M32 18.36v14h14","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    